import { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "antd";
import Title from "../../../components/Title";
import { BranchesOutlined } from "@ant-design/icons";
import DashboardPages from "../../../Dashboard/DashboardPages";
import Tables from "../../../components/Tables";
import {
  TYPE_CHECK_DASHBOARD,
  TYPE_GET_DATE,
  tableMathMatchDailyRevenue,
} from "../../../../helper/const";
import DailyRevenueChartMagicWheel from "../../../components/DailyRevenueChartMagicWheel";
import _ from "lodash";
import {
  formatDataDailyRevenueChartMathMatch,
  formatDataNumberToen,
  formatDataQuantityMytelMathMatchOverview,
  formatDataStatisticTableMathMatch,
  getDateChangeTime,
} from "../../../../helper/helper";
import { selectorDataMathMatch } from "../../../../redux/selector";
import FilterTime from "../../../components/FilterTime";
import RevenueOfChannelChart from "../../../components/RevenueOfChannelChart";
import styled from "styled-components";

export default function Overview({ handleGetData, tabActive }) {
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneMonthAgo)
  );

  const { revenue = {} } = useSelector(selectorDataMathMatch);
  console.log('revenue: ', revenue);
  const {
    dataList = [],
    dataOverview = [],
    dataDetail = [],
  } = revenue.result || {};
  let dataDailyRevenueChart = [];

  useEffect(() => {
    if (tabActive !== "1") return;
    // dispatch(getDataMagicWheel(apiRevenueMagicWheel(startDate, endDate)));
    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive]);

  let quantityRevenue = {
    data: [],
    xField: "time",
    yField: ["totalRevenue", "quantity"],

    annotations: {
      quantity: [],
    },
  };

  let columnsMagicRevenue = { dataKey: [], defineData: [] };
  let revenueOfChannel = {
    data: [],
    xField: "type",
    yField: ["revenue"],
  };

  useMemo(() => {
    quantityRevenue = formatDataQuantityMytelMathMatchOverview(
      dataList,
      TYPE_CHECK_DASHBOARD.overview
    );

    revenueOfChannel = formatDataQuantityMytelMathMatchOverview(
      dataList,
      TYPE_CHECK_DASHBOARD.revenue
    );

    columnsMagicRevenue = formatDataStatisticTableMathMatch(dataOverview);

    dataDailyRevenueChart = formatDataDailyRevenueChartMathMatch(dataDetail);

    const formatDataApi = dataDetail.map((item = {}) => {
      const { title = "", packs = [] } = item;

      const defineDataDailyRevenueTable = {
        MATH_DAILY: 0,
        MATH_WEEKLY: 0,
        MATH_MONTHLY: 0,
        MATH_BUY1: 0,
        MATH_BUY2: 0,
        MATH_BUY3: 0,
        MATH_BUY4: 0,
        MATH_BUY5: 0,
        MATH_BUY6: 0,
        MATH_BUY7: 0,
        MATH_BUY8: 0,
        MATH_BUY9: 0,
        MATH_BUY10: 0,
      };

      let RegisterRevenue = 0;
      let RenewRevenue = 0;
      let TotalRevenue = 0;

      packs.forEach((packItem = {}) => {
        const idPack = packItem.id;

        defineDataDailyRevenueTable[idPack] =
          (defineDataDailyRevenueTable[idPack] || 0) +
          (packItem.amount || 0);

        RegisterRevenue += packItem.total_reg_revenue || 0;
        RenewRevenue += packItem.total_renew_revenue || 0;
        TotalRevenue += packItem.amount || 0;
      });

      const RetailRevenue =
        defineDataDailyRevenueTable.MATH_BUY1 +
        defineDataDailyRevenueTable.MATH_BUY2 +
        defineDataDailyRevenueTable.MATH_BUY3 +
        defineDataDailyRevenueTable.MATH_BUY4 +
        defineDataDailyRevenueTable.MATH_BUY5 +
        defineDataDailyRevenueTable.MATH_BUY6 +
        defineDataDailyRevenueTable.MATH_BUY7 +
        defineDataDailyRevenueTable.MATH_BUY8 +
        defineDataDailyRevenueTable.MATH_BUY9 +
        defineDataDailyRevenueTable.MATH_BUY10;

      return {
        Chargetime: title,
        Day: defineDataDailyRevenueTable.MATH_DAILY,
        Week: defineDataDailyRevenueTable.MATH_WEEKLY,
        Month: defineDataDailyRevenueTable.MATH_MONTHLY,

        BUY1: defineDataDailyRevenueTable.MATH_BUY1,
        BUY2: defineDataDailyRevenueTable.MATH_BUY2,
        BUY3: defineDataDailyRevenueTable.MATH_BUY3,
        BUY4: defineDataDailyRevenueTable.MATH_BUY4,
        BUY5: defineDataDailyRevenueTable.MATH_BUY5,
        BUY6: defineDataDailyRevenueTable.MATH_BUY6,
        BUY7: defineDataDailyRevenueTable.MATH_BUY7,
        BUY8: defineDataDailyRevenueTable.MATH_BUY8,
        BUY9: defineDataDailyRevenueTable.MATH_BUY9,
        BUY10: defineDataDailyRevenueTable.MATH_BUY10,

        RegisterRevenue,
        RenewRevenue,
        RetailRevenue,
        TotalRevenue,
      };
    });


    
    let total = {
      Chargetime: "Total",
      Day: 0,
      Week: 0,
      Month: 0,

      BUY1: 0,
      BUY2: 0,
      BUY3: 0,
      BUY4: 0,
      BUY5: 0,
      BUY6: 0,
      BUY7: 0,
      BUY8: 0,
      BUY9: 0,
      BUY10: 0,

      TotalRevenue: 0,
      RetailRevenue: 0,
      RenewRevenue: 0,
      RegisterRevenue: 0,
    };

    formatDataApi.forEach((item) => {
      total.Day += item.Day || 0;
      total.Week += item.Week || 0;
      total.Month += item.Month || 0;

      total.BUY1 += item.BUY1 || 0;
      total.BUY2 += item.BUY2 || 0;
      total.BUY3 += item.BUY3 || 0;
      total.BUY4 += item.BUY4 || 0;
      total.BUY5 += item.BUY5 || 0;
      total.BUY6 += item.BUY6 || 0;
      total.BUY7 += item.BUY7 || 0;
      total.BUY8 += item.BUY8 || 0;
      total.BUY9 += item.BUY9 || 0;
      total.BUY10 += item.BUY10 || 0;

      total.TotalRevenue += item.TotalRevenue || 0;
      total.RenewRevenue += item.RenewRevenue || 0;
      total.RegisterRevenue += item.RegisterRevenue || 0;
      total.RetailRevenue += item.RetailRevenue || 0;
    });

    for (const key in total) {
      if (typeof total[key] === "number") {
        total[key] = parseFloat(total[key].toFixed(3));
      }
    }
    let data = [total, ...formatDataApi].reverse();
    tableMathMatchDailyRevenue.defineData = data.map((item) => {
      for (let x in item) {
        if (typeof item[x] === "number") {
          item[x] = formatDataNumberToen(item[x]);
        }
      }
      return item;
    });
  }, [revenue.result]);

  return (
    <Container className="reponsitite-container">
      <div className="container-dashboard">
        <div className="d-flex justify-content-end mb-2">
          <FilterTime
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
          />
        </div>
        <Row className="panel panel-sortable">
          <Title titleName="Overview">
            <BranchesOutlined />
          </Title>
          <Col span={24}>
            <Row>
              <Col
                xxl={15}
                xl={15}
                lg={15}
                md={24}
                sm={24}
                xs={24}
                className="container-item"
              >
                <h4 className="pt-3 pe-3">
                  Overview Quantity - Revenue chart:
                </h4>
                <div className="item-chart">
                  <DashboardPages dataDashboard={quantityRevenue} />
                </div>
              </Col>
              <Col
                xxl={9}
                xl={9}
                lg={9}
                md={24}
                sm={24}
                xs={24}
                className="container-item"
              >
                <h4 className="pt-3 pe-3">Revenue of channel chart:</h4>

                <div className="item-chart">
                  <RevenueOfChannelChart dataChart={revenueOfChannel} />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <div id="table-bitel">
        <Tables
          columns={columnsMagicRevenue}
          title="Overview statistic table"
          isHiddenPagination={false}
        />
      </div>
      <div className="container-dashboard pt-0">
        <Row className="panel panel-sortable">
          <Title titleName="Daily Revenue Chart">
            <BranchesOutlined />
          </Title>
          <div className="container-revenueOfChannelChart">
            <div className="revenueOfChannelChart">
              <DailyRevenueChartMagicWheel
                dataRevenueChart={dataDailyRevenueChart}
              />
            </div>
          </div>
        </Row>
      </div>
      <Tables
        columns={tableMathMatchDailyRevenue}
        title="Daily Revenue Table"
      />
      {/* <ProjectInformation id={idProject.mytel} /> */}
    </Container>
  );
}

const Container = styled.div`
  .container-revenueOfChannelChart {
    width: 100%;
    overflow-x: auto;
  }

  .revenueOfChannelChart {
    min-width: 800px;
    overflow-x: scroll;
  }
`;
